<template>
  <div>
    <div class="mb-4" v-for="(entry, index) in items" v-bind:key="entry.id">
      <table width="100%">
        <tr>
          <td width="90%">
            <v-text-field
              dense
              name="fio"
              v-model="items[index].fio"
              class=""
              label="ФИО"
            />
            <v-text-field
              dense
              name="phone"
              v-model="items[index].phone"
              class=""
              label="Телефон"
              v-facade="'#-###-###-##-##'"
              placeholder="7-909-000-00-00"
            />
            <v-text-field
              dense
              name="email"
              v-model="items[index].email"
              class=""
              label="Эл. почта"
            />
            <v-text-field
              dense
              name="position"
              v-model="items[index].position"
              class="mt-1"
              label="Должность"
            />
            <Date
              v-model="items[index].born_date"
              label="Дата рождения"
              :required="false"
              :clearable="true"
              :right="130"
            />
          </td>
          <td>
            <v-icon class="ml-4" @click="add(index)">{{ icon(index) }}</v-icon>
          </td>
        </tr>
      </table>
      <hr class="mt-4 contact-unit-hr" />
    </div>

  </div>
</template>

<script>
import Date from '@/components/Date'
export default {
  components: {
    Date
  },
  props: {
    items: {
      default: function () {
        return ['']
      },
      type: [Array, String]
    },
    label: {
      default: '',
      type: String
    },
  },
  watch: {
    items () {
      if (this.items.length === 0) {
        this.items.push({ fio: '' })
      }
    }
  },
  data: function () {
    return {}
  },
  computed: {
  },
  methods: {
    icon (index) {
      if (index > 0) {
        return 'mdi-minus-circle'
      }
      return 'mdi-plus-circle'
    },
    add (index) {
      if (index > 0) {
        this.items.splice(index, 1)
        return
      }
      this.items.push({ fio: '' })
    }
  }
}
</script>
<style scoped>
.contact-unit-hr {
  width: 100%;
  border-top: dotted 1px;
}
</style>
